export const convertBase64ToImage = (base64: string): string => {
  return `data:image/png;base64,${base64}`; // You can change 'png' to 'jpeg' or 'gif' as needed
}
